import React, { useEffect, useState } from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Checkbox,
    FormGroup,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';

type Props = {
    title?: string;
    name: any;
    answerQuestion?: any;
    onChange: (value: any) => void;
    idQuestion?: string;
    questionType?: string;
    whyQuestion?: boolean;
};

const FieldMultipleAnswers = ({
    title,
    name,
    answerQuestion,
    onChange,
    idQuestion,
    questionType,
    whyQuestion,
}: Props) => {
    const [value, setValue] = useState<string[]>([]);
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');
    const [why, setWhy] = useState('');
    const [touched, setTouched] = useState(false);

    const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target?.value) {
            const data = value.find((v) => v === event.target?.value);
            if (data !== undefined) {
                setValue(value.filter((v) => v !== event.target?.value));
            } else {
                setValue(
                    value.concat((event.target as HTMLInputElement).value)
                );
            }
            setTouched(true);
            setHelperText('');
            setError(false);
        }
    };

    useEffect(() => {
        if (value.length === 0 && touched) {
            setHelperText('La respuesta es obligatoria');
            setError(true);
        } else setError(false);

        const dataValues = {
            idQuestion,
            [name]: value,
            type: questionType,
            why: why,
            error: error || !touched,
        };
        onChange(dataValues);
    }, [value, touched]);

    return (
        <>
            <Grid item xs={12} key={idQuestion}>
                <LabelAnswer text={title} />
                <br />
                <FormControl error={error} fullWidth>
                    <Grid display="flex" justifyContent="center">
                        <FormGroup
                            row
                            onChange={handleCheckChange}
                            sx={{
                                textAlign: 'left',
                                border: error
                                    ? '1px solid #d32f2f'
                                    : '1px solid #E0E0E0',
                                borderRadius: '4px',
                                width: '80%',
                                '.MuiFormHelperText-root': {
                                    textAlign: 'center',
                                },
                            }}
                        >
                            {answerQuestion?.map((a: any, i: number) => (
                                <Grid item xs={6} key={a.id} px="20px">
                                    <FormControlLabel
                                        key={a.id}
                                        value={a.id}
                                        control={<Checkbox />}
                                        label={a.description}
                                        labelPlacement={
                                            (i + 1) % 2 === 1 ? 'start' : 'end'
                                        }
                                        slotProps={{
                                            typography: {
                                                fontFamily: 'Lucida Sans',
                                                fontSize: '14px',
                                                color: '#4b4b4b',
                                            },
                                        }}
                                        style={{
                                            display: 'flex',
                                            justifyContent:
                                                (i + 1) % 2 === 1
                                                    ? 'end'
                                                    : 'start',
                                        }}
                                    />
                                </Grid>
                            ))}
                        </FormGroup>
                    </Grid>
                    <FormHelperText sx={{ textAlign: 'center' }}>
                        {helperText}
                    </FormHelperText>
                </FormControl>
            </Grid>
            {whyQuestion && value.length > 0 && (
                <Grid item xs={12}>
                    <LabelAnswer text="¿Por qué?" isRequired={false} />
                    <br />
                    <FieldTextAreaAutoSize
                        name="why"
                        placeholder="Dejanos aquí las razones de porque"
                        required={false}
                        onChange={(e: any) => setWhy(e.target.value)}
                    />
                </Grid>
            )}
        </>
    );
};

export default FieldMultipleAnswers;
